import React, { Component } from 'react';
import Proptypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { closeModal } from 'actions/modal';
import styled from 'styled-components';

import { Row, Separator, Text, Button } from '@cuemath/comps';

const ButtonStyle = styled.span`
  padding-left: 30px;
`;

const ModalWrapper = styled.div`
  border: 2px solid black;
  margin: 10px;
  padding-left: 20px;
`;

class ReviewConfirmation extends Component {
  static propTypes = {
    actions: Proptypes.shape({
      closeModal: Proptypes.func.isRequired,
    }).isRequired,
    onConfirm: Proptypes.func.isRequired,
    confirmText: Proptypes.string.isRequired,
    headerText: Proptypes.string.isRequired,
    actionType: Proptypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      selectedOption: null,
    };
  }

  handleCancel = () => {
    const { actions } = this.props;

    actions.closeModal();
  };

  handleConfirm = () => {
    const { actions, onConfirm, actionType } = this.props;
    actions.closeModal();
    onConfirm(actionType);
  };

  render() {
    const { confirmText, headerText } = this.props;

    return (
      <React.Fragment>
        <ModalWrapper>
          <Separator height={20} transparent />
          <div>
            <Text size="normal">{confirmText}</Text>
            <Text size="normal">{headerText}</Text>
          </div>
          <Separator height={20} transparent />
          <Row justifyContent="center">
            <Button label="Yes" onClick={() => this.handleConfirm()} />
            <ButtonStyle>
              <Button label="No" onClick={() => this.handleCancel()} />
            </ButtonStyle>
          </Row>
          <Separator height={20} transparent />
        </ModalWrapper>
      </React.Fragment>
    );
  }
}

export default connect(null, dispatch => ({
  actions: bindActionCreators({ closeModal }, dispatch),
}))(ReviewConfirmation);
